"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import { ICustomerSalesProductPayment } from "@/interfaces/customer-sales-product-payment.interfaces";
import { CompanyPaymentsMessages } from "@/messages/customer/company-payments.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { CompanyPaymentTableRow } from "./row";
import { PAYMENTS_TABLE_COLUMNS } from "../../constants";

interface Props {
  data: PaginatedResponse<ICustomerSalesProductPayment>;
  pagination: Pagination;
  messages: CompanyPaymentsMessages;
}

export function CompanyPaymentsTable({ data, pagination, messages }: Props) {
  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {PAYMENTS_TABLE_COLUMNS(messages).map(({ label, align }, index) => (
                <HeaderTableCell align={align} key={`${index}-${label}`}>
                  {label}
                </HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {data.items?.map((payment, index) => (
              <CompanyPaymentTableRow
                key={`${index} - ${payment.id}`}
                payment={payment}
                index={index}
                messages={messages}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => pagination.extend(Number(e.target.value))}
        rowsPerPage={pagination.pageSize}
        page={pagination.pageNumber - 1}
        onPageChange={(_, pageNumber) => pagination.changePage(pageNumber)}
      />
    </>
  );
}

export default CompanyPaymentsTable;
